import AuthenticatedEntity, {AuthenticatedEntityTypeEnum} from "../user/AuthenticatedEntity";
import {none, option, Option} from "ts-option";
import {CreatePartnerBrandPointsApiDto, PartnerBrandPointsApiDto} from "../../api/model/rest";
import {getLoggedUser} from "../../store/view/user";
import JsonConverter from "../../api/helper/JsonConverter";
import moment = require("moment");

const uuidv4 = require("uuid/v4");

export default class PartnerBrandPoints {
	constructor(public readonly id: string,
		public readonly creator: AuthenticatedEntity,
		public readonly createdAt: moment.Moment,
		public readonly amount: number,
		public readonly status: string,
		public readonly quoteReferenceNumber: Option<string>,
		public readonly description: Option<string>,
		public readonly usedPoints: number,
		public readonly quoteId: Option<string>) {}

	static fromJson(json: PartnerBrandPointsApiDto): PartnerBrandPoints {
		const creator = AuthenticatedEntity.fromJson(json.creator);
		return new PartnerBrandPoints(json.id, creator, moment(json.createdAt), json.amount, json.status,
			option(json.quoteReferenceNumber), option(json.description), json.usedPoints, option(json.quoteId))
	}

	static createNew(amount: number, description: Option<string>): PartnerBrandPoints {
		const loggedUser = getLoggedUser().get;
		if (amount <= 0) {
			return new PartnerBrandPoints(uuidv4(), new AuthenticatedEntity(loggedUser.id, AuthenticatedEntityTypeEnum.User),
				moment(), 0, PartnerBrandPointsStatus.NotSaved, none, description, Math.abs(amount), none);
		} else {
			return new PartnerBrandPoints(uuidv4(), new AuthenticatedEntity(loggedUser.id, AuthenticatedEntityTypeEnum.User),
				moment(), amount, PartnerBrandPointsStatus.NotSaved, none, description, 0, none);
		}
	}

	toCreateJson(): CreatePartnerBrandPointsApiDto {
		let json: CreatePartnerBrandPointsApiDto;
		if (this.usedPoints === 0) {
			json = {
				description: this.description.orNull,
				status: PartnerBrandPointsStatus.Submitted,
				amount: this.amount,
			};
		} else {
			json = {
				description: this.description.orNull,
				status: PartnerBrandPointsStatus.Submitted,
				usedPoints: Math.abs(this.usedPoints),
				amount: Math.abs(this.amount),
			};
		}
		return JsonConverter.removeEmptyFields(json)
	}

	copy({status = this.status}) {
		return new PartnerBrandPoints(this.id, this.creator, this.createdAt, this.amount, status, this.quoteReferenceNumber,
			this.description, this.usedPoints, this.quoteId);
	}
}

export enum PartnerBrandPointsStatus {
	NotSaved = "Update Partner Brand to save",
	Pending = "PENDING",
	Submitted = "SUBMITTED"
}